import classNames from "classnames";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import * as actions from "../../Comment/_redux/commentAction";
import "react-tippy/dist/tippy.css";
import {
    getCommentActions,
    removeCommentActions,
    setCommentActions
} from "../helpers";

const TippyAction = ({ children, data: propsData }) => {
    const [open, setOpen] = useState(false);
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { commentSetting } = currentState;
    const dispatch = useDispatch();
    const dataActive = getCommentActions(propsData.commentId);
    const tooltipRef = useRef();
    const [refresh, setRefresh] = useState(false);
    const [test, setTest] = useState(false);
    const [data, setData] = useState({
        totalLike: {
            quantity:
                (propsData?.totalLike || 0) + (dataActive?.type == 1 ? 1 : 0),
            imageUrl: "https://static.vnncdn.net/v1/icon/comment_like_icon.svg",
            type: 1,
            title: "Thích",
            color: "#2D67AD",
            key: "totalLike"
        },
        totalVeryLike: {
            quantity:
                (propsData?.totalVeryLike || 0) +
                (dataActive?.type == 20 ? 1 : 0),
            imageUrl:
                "https://static.vnncdn.net/v1/icon/comment_heart_icon.svg",
            type: 20,
            title: "Yêu thích",
            color: "#DB4B69",
            key: "totalVeryLike"
        },
        totalHappy: {
            quantity:
                (propsData?.totalHappy || 0) + (dataActive?.type == 21 ? 1 : 0),
            imageUrl:
                "https://static.vnncdn.net/v1/icon/comment_happy_icon.svg",
            type: 21,
            title: "Vui",
            color: "#ffa905",
            key: "totalHappy"
        },
        totalSurprise: {
            quantity:
                (propsData?.totalSurprise || 0) +
                (dataActive?.type == 22 ? 1 : 0),
            imageUrl: "https://static.vnncdn.net/v1/icon/comment_wow_icon.svg",
            type: 22,
            title: "Ngạc nhiên",
            color: "#ffa905",
            key: "totalSurprise"
        },
        totalSad: {
            quantity:
                (propsData?.totalSad || 0) + (dataActive?.type == 23 ? 1 : 0),
            imageUrl: "https://static.vnncdn.net/v1/icon/comment_sad_icon.svg",
            type: 23,
            title: "Buồn",
            color: "#ffa905",
            key: "totalSad"
        }
    });
    useEffect(() => {
        // console.log(tooltipRef.current);
        if (window.innerWidth < 767) {
            tooltipRef.current.tippy.store[0].popper.style.display = "none";
            tooltipRef.current.showTooltip();
            setTimeout(() => {
                tooltipRef.current.hideTooltip();
                tooltipRef.current.tippy.store[0].popper.style.display =
                    "block";
            }, 1000);
        }
        // tooltipRef.current.updateReactDom();
        // if(dataActive){
        // const cloneData = JSON.parse(JSON.stringify(data));
        // Object.values(cloneData).forEach(record => {
        //     if(record.type == dataActive){
        //         record.quantity++
        //     }
        // });
        // setData(cloneData);
        // }
    }, []);
    const totalQuantityActions = useCallback(() => {
        return Object.values(data).reduce((pre, cur) => {
            return pre + cur.quantity;
        }, 0);
    }, []);
    const onHandleActions = async function(params) {
        setOpen(false);
        let request = {
            CommentId: propsData.commentId,
            categoryId: commentSetting.categoryId,
            objectId: commentSetting.objectId,
            websiteId: commentSetting.websiteId,
            Type: params.type
        };
        window.parent.postMessage(
            { onSetCookie: { [`vnn_cmt_${propsData.commentId}`]: true } },
            "*"
        );
        if(commentSetting.maxLimitedLikeAndUnlike[`vnn_cmt_${propsData.commentId}`]) return;
        if (dataActive) {
            if (params.type == dataActive.type) {
                // console.log(params);
                removeCommentActions(propsData.commentId);
                data[params.key].quantity--;
                await dispatch(actions.commentUnLike(request));
            } else {
                removeCommentActions(propsData.commentId);
                setCommentActions(propsData.commentId, params);
                data[dataActive.key].quantity--;
                data[params.key].quantity++;
                setRefresh(!refresh);
                // await dispatch(actions.commentUnLike(request));
            }
        } else {
            setCommentActions(propsData.commentId, params);
            data[params.key].quantity++;
            await dispatch(actions.commentLike(request));
        }
        // setData({...data,[data.type]: {...data[data.type],quantity}})
    };
    // console.log(dataActive);
    return (
        <div className='tooltip-actions select-none flex items-center flex-wrap '>
            <Tooltip
                ref={tooltipRef}
                arrow
                // onRequestClose={() => setOpen(false)}
                // unmountHTMLWhenHide
                html={
                    <div className='h-[24px]'>
                        {Object.values(data).map((record, index) => (
                            <button
                                onClick={() => {
                                    onHandleActions(record);
                                    tooltipRef.current.hideTooltip();
                                }}
                                className='comment-tooltip transition-all mr-[10px] '>
                                <span class='tooltiptext'>{record.title}</span>
                                <img
                                    className='hover:scale-[1.3] transition-all'
                                    src={record.imageUrl}
                                    alt='icon action'
                                />
                            </button>
                        ))}
                    </div>
                }
                interactive={true}
                position='top-start'
                // arrow={true}
                theme='light'
                hideOnClick={true}
                touchHold={true}
                className='font-notosans-regular mr-[25px] '>
                <button
                    className='select-none'
                    onTouchEnd={e => {
                        // alert('touch')
                    }}
                    onClick={() => {
                        onHandleActions({ type: 1, key: "totalLike" });
                    }}
                    // onMouseOver={() => setOpen(true)}
                    // onMouseMove={() => {
                    //     console.log('running !');
                    //     // console.log(tooltipRef.current);
                    //     // tooltipRef.current.hideTooltip()
                    // }}
                >
                    {dataActive ? (
                        (() => {
                            const dataResult = Object.values(data).find(
                                record => record.type === dataActive.type
                            );
                            if (!dataResult) return "";
                            return (
                                <span
                                    style={{ color: dataResult.color }}
                                    className='font-notosans-bold'>
                                    {dataResult?.title}
                                </span>
                            );
                        })()
                    ) : (
                        <span>Thích</span>
                    )}
                </button>
            </Tooltip>
            <Tooltip
                ref={tooltipRef}
                arrow
                // flipOnUpdate={true}
                html={
                    <div className='flex '>
                        {Object.values(data).map((record, index) => (
                            <div
                                className={classNames(
                                    "flex text-[14px] items-center ",
                                    {
                                        "mr-[10px]":
                                            index <
                                            Object.values(data).length - 1
                                    }
                                )}
                                key={index}>
                                <img
                                    className='mr-[5px] '
                                    src={record.imageUrl}
                                    alt='action result icon'
                                />
                                {record.quantity !== 0 ? record.quantity : ""}
                            </div>
                        ))}
                    </div>
                }
                // boundary="viewport"
                position='top-start'
                // arrow={true}
                trigger='click'
                className='cursor-pointer'
                // animation="fade"
                interactive={false}
                // appendTo="parent"
                // open={true}
                // unmountHTMLWhenHide={true}
                // delay={1000}
                popperOptions={{}}
                theme='light'>
                <div className='flex items-center flex-row-reverse mr-[5px] '>
                    {Object.values(data)
                        .reverse()
                        .map(
                            (record, index) =>
                                // record.quantity > 0 && (
                                //     <img
                                //         style={{ zIndex: index + 1 }}
                                //         className='m-w-[24px] max-w-[24px] p-[5px] rounded-[50%] bg-[#EEF5FF] ml-[-10px] '
                                //         key={index}
                                //         src={record.imageUrl}
                                //         alt=''
                                //     />
                                // )
                                record.quantity > 0 && (
                                    <div style={{ zIndex: index + 1 }} className={classNames('p-[5px] w-[24px] h-[24px] rounded-[50%] bg-[#EEF5FF]', {
                                        "ml-[-10px]":
                                            index <
                                            Object.values(data)
                                                .length -
                                                1
                                    })}>
                                        <img
                                            className={classNames(
                                                "w-[14px] h-[14px] "
                                            )}
                                            key={index}
                                            src={record.imageUrl}
                                            alt=''
                                        />
                                    </div>
                                )
                        )}
                </div>
            </Tooltip>
            {totalQuantityActions() > 0 && (
                <span className='text-[#838383] text-[14px] '>
                    {totalQuantityActions()}
                </span>
            )}
        </div>
    );
};

export default TippyAction;
